<template>
    <div class="sw-modal form-entry edit-form-component edit-automation">
        <div v-click-outside="cancel" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4 v-if="editingAutomation"><i class="fas fa-cogs"></i>Edit Automation</h4>
                    <h4 v-if="!editingAutomation"><i class="fas fa-cogs"></i>Add an Automation</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <ValidationObserver ref="automationForm">
                    <form v-on:submit.prevent="saveAutomation()" >

                        <div class="row question">
                            <div class="col-12 question__question">
                                Name your automation
                            </div>
                            <div class="col-12">
                                <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                    <input ref="nameInput" type="text" v-model="automation.name" class="short-question">
                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="row question">
                            <div class="col-12 question__question">
                                Add to which flow?
                                <i v-on:mouseenter="showTooltipFlow = true" v-on:mouseleave="showTooltipFlow = false" class="fas fa-info-circle"></i>
                                <tooltip v-bind:visible="showTooltipFlow" v-bind:position="'bottom'" v-bind:text="'Choose when your automation will run:<ul><li>after a booking is placed</li><li>before or after check-in</li><li>before or after check-out</li></ul>'"></tooltip>
                            </div>
                            <div class="col-12">
                                <ul class="edit-automation__multiple-choice">
                                    <li v-on:click="setStrategy('after-booking')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.when.strategy === 'after-booking'}">
                                        <i class="far fa-calendar-check"></i><br/>
                                        Booking
                                        <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.when.strategy === 'after-booking'}"><div></div></div>
                                    </li>
                                    <li v-on:click="setStrategy('before-or-after-arrival')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.when.strategy === 'before-or-after-arrival'}">
                                        <i class="fas fa-walking automation-process-event__icon--person"></i>
                                        <i class="fas fa-door-open fa-flip-horizontal"></i><br/>
                                        Check-In
                                        <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.when.strategy === 'before-or-after-arrival'}"><div></div></div>
                                    </li>
                                    <li v-on:click="setStrategy('before-or-after-departure')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.when.strategy === 'before-or-after-departure'}">
                                        <i class="fas fa-door-open"></i>
                                        <i class="fas fa-walking automation-process-event__icon--person"></i><br/>
                                        Check-Out
                                        <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.when.strategy === 'before-or-after-departure'}"><div></div></div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="row question" v-if="!editingAutomation">
                            <div class="col-12 question__question">
                                Type of automation
                                <i v-on:mouseenter="showTooltipAutomationType = true" v-on:mouseleave="showTooltipAutomationType = false" class="fas fa-info-circle"></i>
                                <tooltip v-bind:visible="showTooltipAutomationType"
                                         v-bind:position="'bottom'"
                                         v-bind:text="'Choose from 8 types of automation:<ul>\
                                            <li><b>Form</b> - sends an invite to a guest to fill in a form</li>\
                                            <li><b>Email</b> - sends an email to a guest</li>\
                                            <li><b>WhatsApp</b> - sends an WhatsApp message to a guest</li>\
                                            <li><b>SMS</b> - sends an SMS to a guest</li>\
                                            <li><b>Front desk Form</b> - generates a form that staff at<br/>your front desk will ask the guest to fill in upon arrival. (Note: You need to set up your Front Desk site to access these - see Configure Establishments in account menu)</li>\
                                            <li><b>Task</b> - adds a Task to the Calendar</li>\
                                            <li><b>Upsell</b> - sends an email to the guest offering a room upgrade at a discounted price</li>\
                                            <li><b>Webhook</b> - sends a request to a remote server</li>\
                                            </ul>'"></tooltip>
                            </div>
                            <div class="col-12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <input type="hidden" v-model="automation.type"/>
                                    <ul class="edit-automation__multiple-choice edit-automation__multiple-choice--tall">
                                        <li v-on:click="setAutomationType('send-omni-channel-guest-form')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'send-omni-channel-guest-form'}">
                                            <i class="fab fa-wpforms"></i><br/>
                                            Form<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'send-omni-channel-guest-form'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('send-email')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'send-email'}">
                                            <i class="far fa-envelope"></i><br/>
                                            Email<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'send-email'}"><div></div></div>
                                        </li>
                                        <li v-if="canShowWhatsApp" v-on:click="setAutomationType('send-whatsapp')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'send-whatsapp'}">
                                            <i class="fas fa-comments"></i><br/>
                                            WhatsApp<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'send-whatsapp'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('send-sms')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'send-sms'}">
                                            <i class="fas fa-sms"></i><br/>
                                            SMS<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'send-sms'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('guest-form')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'guest-form'}">
                                            <i class="fas fa-concierge-bell"></i><br/>
                                            Front desk Form
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'guest-form'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('todo')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'todo'}">
                                            <i class="fas fa-list"></i><br/>
                                            Task<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'todo'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('upsell')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'upsell'}">
                                            <i class="fas fa-cart-plus"></i><br/>
                                            Upsell<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'upsell'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setAutomationType('webhook')" v-bind:class="{'edit-automation__multiple-choice--selected': automation.type === 'webhook'}">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 92 81"
                                                 fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" class="automation__header--webhook">
                                                <path d="M59.165 62.735l1.967 2.483c3.4 3.469 9.202 3.66 12.836.414 3.801-3.374 3.967-9.008.4-12.509-3.5-3.438-9.501-3.756-12.769-.128-1.967 2.197-4 2.483-6.601 2.419l-20.17-.032c.433 9.04-3.134 14.642-10.235 15.979-6.935 1.305-13.303-2.069-15.57-8.244-2.567-7.003.6-12.605 9.735-17.06l-2.067-7.162C6.722 40.963-.712 50.193.054 60.57c.667 9.167 8.402 17.284 17.87 18.748 5.134.796 9.968-.032 14.436-2.451 5.768-3.119 9.101-8.053 10.668-14.132h16.136zm-6.301-36.318c.4-.987.8-1.782 1.1-2.61 1.034-2.992.4-5.698-1.6-8.117-2.434-2.96-6.735-4.043-10.369-2.706-3.668 1.337-6.034 4.807-5.868 8.594.167 3.883 2.867 7.321 7.068 8.021 2.5.414 3.734 1.528 4.867 3.502 3.301 5.825 6.768 11.554 10.202 17.347 8.235-5.22 15.036-5.061 20.104.382a12.41 12.41 0 0 1 .233 16.774c-5.034 5.666-11.802 5.888-19.537 1.114l-6.134 4.902c7.835 7.448 19.003 8.435 27.838 2.642 8.635-5.666 11.602-16.52 7.235-25.687-3.634-7.608-13.736-14.706-27.172-10.727l-7.968-13.432zm-10.702 7.13c-8.701-4.201-11.902-9.74-9.802-16.52 1.867-5.984 8.134-9.867 14.502-8.976 3.2.477 5.968 1.719 8.168 4.075 3.301 3.597 4.034 7.798 3.034 12.477l7.535 1.942c3.201-8.403-.567-18.207-8.768-23.236-8.568-5.252-19.637-4.169-26.905 2.673-3.801 3.565-5.868 7.926-6.368 12.987-.667 7.098 2.4 12.859 7.601 17.793l-8.268 13.178c-.733.064-1.2.064-1.666.128-5.401.732-9.235 5.347-8.335 10.026 1.033 5.315 6.101 8.562 11.269 7.257 5.501-1.369 8.435-6.43 6.368-11.65-.767-1.878-.3-3.087.667-4.551l10.969-17.602z"
                                                      stroke="none"/>
                                            </svg>
                                            Webhook<br/>&nbsp;
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.type === 'webhook'}"><div></div></div>
                                        </li>
                                    </ul>
                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="row question" v-if="!editingAutomation && hasTemplates">
                            <div class="col-12 question__question">
                                Create from a template?
                            </div>
                            <div class="col-12">
                                <input type="checkbox" v-model="usingTemplate">
                                Yes, use a template to save time
                            </div>
                            <div class="col-12 edit-automation__when" v-show="usingTemplate">
                                <select v-model="templateReference">
                                    <option value="">Select a template</option>
                                    <option v-for="(template, index) in templateChoices" v-bind:key="index" v-bind:value="template.reference">{{template.displayName}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row question" v-if="canSetCommunicationMode">
                            <div class="col-12 question__question">
                                To whom is communication sent?
                                <i v-on:mouseenter="showTooltipCommunicationMode = true" v-on:mouseleave="showTooltipCommunicationMode = false" class="fas fa-info-circle"></i>
                                <tooltip v-bind:visible="showTooltipCommunicationMode"
                                         v-bind:position="'bottom'"
                                         v-bind:text="'Communication can be sent to You, the Guest, or a Third Party.<br/><br/>\
                                                       We recommend that you start a new automation in the \'You\' mode.\
                                                       You can then check the content and layout of your emails, forms etc and\
                                                       forward them on to guests. Once happy, you can change the mode\
                                                       to automatically send to the guest.<br/><br/>Alternatively, you can\
                                                       send communication to a third party.<br/><br/>With both the \
                                                       \'Guest\' and \'Third Party\' modes, you can choose to be BCC\'d \
                                                       in on the communication'"></tooltip>
                            </div>
<!--                            <div class="col-12 question__note">-->
<!--                                When creating a new Automation this is always "Host only", to allow you to-->
<!--                                approve the design before sending automatically to the guest.-->
<!--                            </div>-->
                            <div class="col-12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <input type="hidden" v-model="automation.communicationMode"/>
                                    <ul class="edit-automation__multiple-choice edit-automation__multiple-choice--tall">
                                        <li v-on:click="setCommunicationMode('host-only')"
                                            v-bind:class="{'edit-automation__multiple-choice--selected': automation.communicationMode === 'host-only'}">
                                            <i class="fas fa-house-user"></i><br/>
                                            You<br/>
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.communicationMode === 'host-only'}"><div></div></div>
                                        </li>
<!--                                        <li v-on:click="setCommunicationMode('bcc-host')"-->
<!--                                            v-bind:class="{'edit-automation__multiple-choice&#45;&#45;selected': automation.communicationMode === 'bcc-host'}">-->
<!--                                            <i class="fas fa-house-user"></i><i class="fas fa-plus edit-automation__multiple-choice-plus"></i><i class="fas fa-user"></i><br/>-->
<!--&lt;!&ndash;                                            <i class="fas fa-user"></i><i class="fas fa-plus edit-automation__multiple-choice-plus"></i><i class="fas fa-house-user"></i><br/>&ndash;&gt;-->
<!--                                            {{sendingToGuestOrAgent}} &amp;<br/>BCC Host-->
<!--                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio&#45;&#45;selected': automation.communicationMode === 'bcc-host'}"><div></div></div>-->
<!--                                        </li>-->
                                        <li v-on:click="setCommunicationMode('guest-only')"
                                            v-bind:class="{'edit-automation__multiple-choice--selected': automation.communicationMode === 'guest-only'}">
                                            <i class="fas fa-user"></i><br/>
                                            {{sendingToGuestOrAgent}}<br/>
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.communicationMode === 'guest-only'}"><div></div></div>
                                        </li>
                                        <li v-on:click="setCommunicationMode('third-party'); setFocusOnThirdPartyEmail()"
                                            v-bind:class="{'edit-automation__multiple-choice--selected': automation.communicationMode === 'third-party'}">
                                            <i class="fas fa-user-plus"></i><br/>
                                            Third Party<br/>
                                            <div class="edit-automation__multiple-choice-radio" v-bind:class="{'edit-automation__multiple-choice-radio--selected': automation.communicationMode === 'third-party'}"><div></div></div>
                                        </li>
<!--                                        <tooltip v-bind:visible="showTooltipCommunicationModeDisabled"-->
<!--                                                 v-bind:position="'bottom'"-->
<!--                                                 v-bind:text="'A new automation is disabled to start and the communication\-->
<!--                                                               mode is set to Host only.<br/><br/>This is so that the automation\-->
<!--                                                               doesn\'t execute while you\'re still busy editing it.\-->
<!--                                                               You can come back and change this later.'"></tooltip>-->
                                    </ul>
                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div v-if="isCommunicationThirdParty" class="row question">
                            <div class="col-12 question__question">
                                Third party email address
                            </div>
                            <div class="col-12">
                                <ValidationProvider rules="required|email" v-slot="{ errors }">
                                    <input v-model="automation.thirdPartyEmail" ref="thirdPartyEmailInput" type="text" class="form-account__text short-question">
                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div v-if="canSetCommunicationMode && !isCommunicationHostOnly && isSendEmail" class="row question">
                            <div class="col-12 question__question">
                                BCC yourself?
                            </div>
                            <div class="col-12 edit-automation__apply-to-all">
                                <input type="radio" v-model="automation.bccHost" v-bind:value="true"/> Yes
                                <input type="radio" v-model="automation.bccHost" v-bind:value="false"/> No
                            </div>
                        </div>

                        <div v-if="isSendOmniChannel" class="row question">
                            <div class="col-12 question__question">
                                Notify via mobile as well as email?
                                <i v-on:mouseenter="showTooltipSendSMS = true" v-on:mouseleave="showTooltipSendSMS = false" class="fas fa-info-circle"></i>
                                <tooltip v-bind:visible="showTooltipSendSMS"
                                         v-bind:position="'bottom'"
                                         v-bind:text="'Send an WhatsApp (standard template) or SMS (editable) to the booker or main guest with an invite to fill in the form. <br><br>Will only be sent if a mobile number for the booker or guest is supplied. <br><br>To be able to select WhatsApp, you need to have WhatsApp active and an approved form invite template.'"></tooltip>
                            </div>
                            <div class="col-12 edit-automation__apply-to-all">
                                <input type="radio" v-model="messageMethod" value="no"/> No
                                <template v-if="canShowWhatsAppForForm"><input type="radio" v-model="messageMethod" value="whatsapp"/> WhatsApp</template>
                                <input type="radio" v-model="messageMethod" value="sms"/> SMS
                            </div>
                        </div>

                        <div class="row question">
                            <div class="col-12 question__question">
                                When should this take place?
                            </div>
                            <div class="col-12 edit-automation__when">
                                <select v-model="automation.when.numberOfDaysFrom" v-on:change="checkTimeOfDayWhenChangingStrategy">
                                    <option v-for="option in daysFromOptions" v-bind:key="option.key" v-bind:value="option.key">{{option.value}}</option>
                                </select>
                                <template v-if="shouldShowTimeOfDay">
                                    at
                                    <select v-model="automation.when.timeOfDay">
                                        <option value="06:00">06:00</option>
                                        <option value="07:00">07:00</option>
                                        <option value="08:00">08:00</option>
                                        <option value="09:00">09:00</option>
                                        <option value="10:00">10:00</option>
                                        <option value="11:00">11:00</option>
                                        <option value="12:00">12:00</option>
                                        <option value="13:00">13:00</option>
                                        <option value="14:00">14:00</option>
                                        <option value="15:00">15:00</option>
                                        <option value="16:00">16:00</option>
                                        <option value="17:00">17:00</option>
                                        <option value="18:00">18:00</option>
                                        <option value="19:00">19:00</option>
                                        <option value="20:00">20:00</option>
                                    </select>
                                </template>
                            </div>
                        </div>

                        <div class="row question" v-on:click="toggleAdvancedOptions()">
                            <div class="col-6 question__question">
                                Advanced options
                            </div>
                            <div class="col-6 edit-automation__advanced_options_toggle">
                                <i v-if="showAdvancedOptions" class="fas fa-chevron-up"></i>
                                <i v-if="!showAdvancedOptions" class="fas fa-chevron-down"></i>
                            </div>
                        </div>

                        <div v-show="showAdvancedOptions">

                            <div v-if="isOmniChannelGuestForm" class="row question">
                                <div class="col-12 question__question">
                                    Show booking summary to guest?
                                    <i v-on:mouseenter="showTooltipShowBookingSummary = true" v-on:mouseleave="showTooltipShowBookingSummary = false" class="fas fa-info-circle"></i>
                                    <tooltip v-bind:visible="showTooltipShowBookingSummary"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'Show a summary including dates, guest allocations and pricing information. Includes the option for a guest to request an amendment.'"></tooltip>
                                </div>
                                <div class="col-12 edit-automation__apply-to-all">
                                    <input type="radio" v-model="automation.showBookingSummary" v-bind:value="true"/> Yes
                                    <input type="radio" v-model="automation.showBookingSummary" v-bind:value="false"/> No
                                </div>
                            </div>

                            <div v-if="isOmniChannelGuestForm" class="row question">
                                <div class="col-12 question__question">
                                    Show pricing in booking summary?
                                    <i v-on:mouseenter="showTooltipShowPricing = true" v-on:mouseleave="showTooltipShowPricing = false" class="fas fa-info-circle"></i>
                                    <tooltip v-bind:visible="showTooltipShowPricing"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'Include pricing information in the booking summary shown to the guest, as well as any PDFs of completed forms sent to the guest.'"></tooltip>
                                </div>
                                <div class="col-12 edit-automation__apply-to-all">
                                    <input type="radio" v-model="automation.showPricing" v-bind:value="true"/> Yes
                                    <input type="radio" v-model="automation.showPricing" v-bind:value="false"/> No
                                </div>
                            </div>

                            <div v-if="isOmniChannelGuestForm" class="row question">
                                <div class="col-12 question__question">
                                    Show on Front Desk App?
                                    <i v-on:mouseenter="showTooltipShowOnFrontDeskApp = true" v-on:mouseleave="showTooltipShowOnFrontDeskApp = false" class="fas fa-info-circle"></i>
                                    <tooltip v-bind:visible="showTooltipShowOnFrontDeskApp"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'Show forms on the Front Desk App. Normally only Front Desk Forms are shown on the Front Desk App.'"></tooltip>
                                </div>
                                <div class="col-12 edit-automation__apply-to-all">
                                    <input type="radio" v-model="automation.showOnFrontDeskApp" v-bind:value="true"/> Yes
                                    <input type="radio" v-model="automation.showOnFrontDeskApp" v-bind:value="false"/> No
                                </div>
                            </div>

                            <div v-if="isOmniChannelGuestForm" class="row question">
                                <div class="col-12 question__question">
                                    Nudge guest to complete form?
                                    <i v-on:mouseenter="showTooltipNudgeGuest = true" v-on:mouseleave="showTooltipNudgeGuest = false" class="fas fa-info-circle"></i>
                                    <tooltip v-bind:visible="showTooltipNudgeGuest"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'If the guest hasn\'t completed the form, send a reminder message.<br><br>\
                                                When is this sent?<br>\
                                                - not sent if check-in < 48 hours away<br>\
                                                - after 48 hours if check-in < 1 week away<br>\
                                                - after 4 days if check-in < 2 weeks away<br>\
                                                - after 1 week if check-in < 1 month away<br>\
                                                - after 2 weeks otherwise'"></tooltip>
                                </div>
                                <div class="col-12 edit-automation__apply-to-all">
                                    <input type="radio" v-model="automation.useDueDate" v-bind:value="true"/> Yes
                                    <input type="radio" v-model="automation.useDueDate" v-bind:value="false"/> No
                                </div>
                            </div>

                            <div class="row question">
                                <div class="col-12 question__question">
                                    Pause new Tasks?
                                    <i v-on:mouseenter="showTooltipPauseNewTasks = true" v-on:mouseleave="showTooltipPauseNewTasks = false" class="fas fa-info-circle"></i>
                                    <tooltip v-bind:visible="showTooltipPauseNewTasks"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'By default new Tasks are scheduled and execute at the scheduled Time. By setting this to \'Yes\', newly created Tasks will be paused instead.'"></tooltip>
                                </div>
                                <div class="col-12 edit-automation__apply-to-all">
                                    <input type="radio" v-model="automation.pauseNewTasks" v-bind:value="true"/> Yes
                                    <input type="radio" v-model="automation.pauseNewTasks" v-bind:value="false"/> No
                                </div>
                            </div>

                            <div class="row question edit-automation__apply-to-all">
                                <div class="col-12 question__question">
                                    Apply to all bookings?
                                    <i v-if="automation.active" v-on:mouseenter="showTooltipConditions = true" v-on:mouseleave="showTooltipConditions = false" class="fas fa-info-circle edit-automation__apply-to-all__tooltip--warning"></i>
                                    <tooltip v-if="automation.active"
                                             v-bind:visible="showTooltipConditions"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'<span class=\'text-error\'><b>Note:</b> Conditions cannot be edited while the Automation is turned on. Please turn this Automation off to edit, and on again afterwards.</span><br><br>Does this Automation apply to all Bookings, or a subset? Select \'No\' and add conditions to select which Bookings this applies to.'"></tooltip>

                                    <i v-if="!automation.active" v-on:mouseenter="showTooltipConditions = true" v-on:mouseleave="showTooltipConditions = false" class="fas fa-info-circle"></i>
                                    <tooltip v-if="!automation.active"
                                             v-bind:visible="showTooltipConditions"
                                             v-bind:position="'bottom'"
                                             v-bind:text="'Does this Automation apply to all Bookings, or a subset? Select \'No\' and add conditions to select which Bookings this applies to.'"></tooltip>
                                </div>
                                <div class="col-12">
                                    <input type="radio" v-model="automation.appliesToAllBookings" v-bind:value="true" v-on:click="setAppliesToAllBookings(true)" v-bind:disabled="automation.active"/> Yes
                                    <input type="radio" v-model="automation.appliesToAllBookings" v-bind:value="false" v-on:click="setAppliesToAllBookings(false)" v-bind:disabled="automation.active"/> No
                                </div>
                            </div>

                            <div class="row question" v-show="!automation.appliesToAllBookings">
                                <div class="col-12 question__question" v-bind:class="{'text-temporary' : automation.active}">
                                    Which bookings does this apply to?
                                </div>
                                <div class="col-12 edit-automation__conditions" v-if="!automation.appliesToAllBookings" v-bind:class="{'text-temporary' : automation.active}">
                                    <div v-for="(condition, index) in automation.conditions" v-bind:key="index" class="row edit-dynamic-list__item">
                                        <div v-if="index > 0" class="col-12 edit-automation-condition__and">
                                            AND
                                        </div>

                                        <div class="col-12 edit-automation-condition">
                                            <select v-model="condition.type" v-on:change="conditionTypeChanged(condition)" v-bind:disabled="automation.active">
                                                <option value="">Condition</option>
                                                <option v-if="isPMSEstablishment" value="booking-source">Channel</option>
                                                <option value="ota-booker">Agent email</option>
                                                <option value="booking-date">Date booked</option>
                                                <option value="room-type">Room Type</option>
                                                <option value="length-of-stay">Length of stay</option>
                                                <option value="stay-day-of-week">Day of week</option>
                                                <option value="booking-to-arrival">Book to arrive</option>
                                                <option value="payment-state">Payment state</option>
                                                <option value="family-booking">Family booking</option>
                                                <option value="number-of-guests">Number of guests</option>
                                                <option value="number-of-rooms">Number of rooms</option>
                                            </select>

                                            <div class="edit-automation-condition__operator">
                                                <div v-on:click.stop="toggleConditionOptions(condition, index)">
                                                    <i v-if="isConditionOperatorEqual(condition.operator)" class="fas fa-equals" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                    <i v-if="isConditionOperatorNotEqual(condition.operator)" class="fas fa-not-equal" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                    <i v-if="isConditionOperatorLessThan(condition.operator)" class="fas fa-less-than" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                    <i v-if="isConditionOperatorGreaterThan(condition.operator)" class="fas fa-greater-than" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                    <span v-if="isConditionOperatorIn(condition.operator)" class="edit-automation-condition__operator-in" v-bind:class="{'text-temporary' : automation.active}">IN</span>
                                                    <i v-if="!isConditionTypeAgent(condition.type)" class="fas fa-angle-down edit-automation-condition__operator-selector" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                </div>
                                                <div v-show="!automation.active && isShowConditionOptions(index)" class="edit-automation-condition__operator-operators" v-click-outside="hideAllConditionOptions">
                                                    <ul>
                                                        <li v-if="allowEqualsOperator(condition.type)" v-on:click.stop="selectConditionOperator(index, 'equals')"><i class="fas fa-equals"></i></li>
                                                        <li v-if="allowNotEqualsOperator(condition.type)" v-on:click.stop="selectConditionOperator(index, 'not-equals')"><i class="fas fa-not-equal"></i></li>
                                                        <li v-if="allowLessThanOperator(condition.type)" v-on:click.stop="selectConditionOperator(index, 'less-than')"><i class="fas fa-less-than"></i></li>
                                                        <li v-if="allowGreaterThanOperator(condition.type)" v-on:click.stop="selectConditionOperator(index, 'greater-than')"><i class="fas fa-greater-than"></i></li>
                                                        <li v-if="allowInOperator(condition.type)" v-on:click.stop="selectConditionOperator(index, 'in')"><strong>IN</strong></li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="edit-automation-condition__value">
                                                <template v-if="isConditionValueMultipleChoice(condition.type, condition.operator)">
                                                    <ValidationProvider rules="required" v-slot="{ errors }"  v-bind:skipIfEmpty="false">
                                                        <select v-model="condition.value" v-bind:disabled="automation.active">
                                                            <option value="">Select</option>
                                                            <option v-for="(conditionValueOption, index) in conditionValueOptions(condition.type)"
                                                                    v-bind:key="index"
                                                                    v-bind:value="conditionValueOption.value">{{conditionValueOption.label}}</option>
                                                        </select>
                                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </template>
                                                <template v-else-if="isConditionValueDate(condition.type)">
                                                    <ValidationProvider rules="required" v-slot="{ errors }" v-bind:skipIfEmpty="false">
                                                        <flat-pickr v-model="condition.value" v-bind:config="flatPickrConfig" id="date" v-bind:disabled="automation.active"></flat-pickr>
                                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </template>
                                                <template v-else-if="isConditionValueSelectMultiple(condition.type, condition.operator)">
                                                    <div class="edit-automation-condition__value--select-multiple"
                                                         v-on:click.stop="toggleMultipleSelector(index)"
                                                         v-bind:class="{'edit-automation-condition__value--select-multiple--open' : showMultipleSelectorIndex != null && showMultipleSelectorIndex === index}">
                                                        <ValidationProvider rules="required" v-slot="{ errors }" v-bind:skipIfEmpty="false">
                                                            <input type="hidden" v-model="condition.value"/>
                                                            {{numberSelectedForCondition(condition)}} selected
                                                            <i class="fas fa-angle-down" v-if="showMultipleSelectorIndex === null || showMultipleSelectorIndex !== index" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                            <i class="fas fa-angle-up" v-if="showMultipleSelectorIndex != null && showMultipleSelectorIndex === index" v-bind:class="{'text-temporary' : automation.active}"></i>
                                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="edit-automation-condition__cta">
                                                <template v-if="automation.active">
                                                    <i class="fas fa-trash-alt"></i>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click.stop="deleteCondition(index)" class="edit-dynamic-list__action"><i class="fas fa-trash-alt"></i></a>
                                                </template>
                                            </div>
                                        </div>

                                        <div v-if="showMultipleSelectorIndex != null && showMultipleSelectorIndex === index" class="col-12 edit-automation-condition">
                                            <div class="edit-automation-condition__value__multiple-selector">
                                                <table>
                                                    <template v-if="isConditionTypeRoomType(condition.type)">
                                                        <tr v-for="(roomType, index) in roomTypes" v-bind:key="index">
                                                            <td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, roomType.reference)"
                                                                    v-on:change="updateInValueOnCondition(condition, roomType.reference, $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>{{roomType.name}}</td>
                                                        </tr>
                                                    </template>
                                                    <template v-if="isConditionTypePaymentState(condition.type)">
                                                        <tr><td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, 'waiting-for-deposit')"
                                                                    v-on:change="updateInValueOnCondition(condition, 'waiting-for-deposit', $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>Waiting for deposit</td>
                                                        </tr>
                                                        <tr><td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, 'confirmed')"
                                                                    v-on:change="updateInValueOnCondition(condition, 'confirmed', $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>Deposit received</td>
                                                        </tr>
                                                        <tr><td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, 'paid')"
                                                                    v-on:change="updateInValueOnCondition(condition, 'paid', $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>Paid</td>
                                                        </tr>
                                                        <tr><td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, 'outstanding-account')"
                                                                    v-on:change="updateInValueOnCondition(condition, 'outstanding-account', $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>Outstanding account</td>
                                                        </tr>
                                                    </template>
                                                    <template v-if="isConditionTypeChannel(condition.type)">
                                                        <tr v-for="(conditionValueOption, index) in conditionValueOptions(condition.type)" v-bind:key="index">
                                                            <td><input type="checkbox"
                                                                    v-bind:checked="isInValueSetOnCondition(condition, conditionValueOption.value)"
                                                                    v-on:change="updateInValueOnCondition(condition, conditionValueOption.value, $event.target.checked)"
                                                                    v-bind:disabled="automation.active"></td>
                                                            <td>{{conditionValueOption.label}}</td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="addingCondition" class="row edit-dynamic-list__item">
                                        <div class="col-12">
                                            AND
                                        </div>

                                        <div class="col-12 edit-automation-condition">
                                            <select v-model="newConditionType" ref="addConditionType" @change="newConditionTypeChanged">
                                                <option value="">Condition</option>
                                                <option v-if="isPMSEstablishment" value="booking-source">Channel</option>
                                                <option value="ota-booker">Agent email</option>
                                                <option value="booking-date">Date booked</option>
                                                <option value="room-type">Room Type</option>
                                                <option value="length-of-stay">Length of stay</option>
                                                <option value="stay-day-of-week">Day of week</option>
                                                <option value="booking-to-arrival">Book to arrive</option>
                                                <option value="payment-state">Payment state</option>
                                                <option value="family-booking">Family booking</option>
                                                <option value="number-of-guests">Number of guests</option>
                                                <option value="number-of-rooms">Number of rooms</option>
                                            </select>
                                            <div class="edit-automation-condition__operator">
                                                <div v-on:click.stop="toggleNewConditionOptions">
                                                    <i v-if="isConditionOperatorEqual(newConditionOperator)" class="fas fa-equals"></i>
                                                    <i v-if="isConditionOperatorNotEqual(newConditionOperator)" class="fas fa-not-equal"></i>
                                                    <i v-if="isConditionOperatorLessThan(newConditionOperator)" class="fas fa-less-than"></i>
                                                    <i v-if="isConditionOperatorGreaterThan(newConditionOperator)" class="fas fa-greater-than"></i>
                                                    <span v-if="isConditionOperatorIn(newConditionOperator)" class="edit-automation-condition__operator-in">IN</span>
                                                    <i v-if="!isConditionTypeAgent(newConditionType)" class="fas fa-angle-down edit-automation-condition__operator-selector"></i>
                                                </div>
                                                <div v-show="isShowNewConditionOptions" class="edit-automation-condition__operator-operators" v-click-outside="hideNewConditionOptions">
                                                    <ul>
                                                        <li v-if="allowEqualsOperator(newConditionType)" v-on:click.stop="selectNewConditionOperator('equals')"><i class="fas fa-equals"></i></li>
                                                        <li v-if="allowNotEqualsOperator(newConditionType)" v-on:click.stop="selectNewConditionOperator('not-equals')"><i class="fas fa-not-equal"></i></li>
                                                        <li v-if="allowLessThanOperator(newConditionType)" v-on:click.stop="selectNewConditionOperator('less-than')"><i class="fas fa-less-than"></i></li>
                                                        <li v-if="allowGreaterThanOperator(newConditionType)" v-on:click.stop="selectNewConditionOperator('greater-than')"><i class="fas fa-greater-than"></i></li>
                                                        <li v-if="allowInOperator(newConditionType)" v-on:click.stop="selectNewConditionOperator('in')"><strong>IN</strong></li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="edit-automation-condition__value">
                                                <template v-if="isConditionValueMultipleChoice(newConditionType, newConditionOperator)">
                                                    <ValidationProvider rules="required" v-slot="{ errors }" v-bind:skipIfEmpty="false">
                                                        <select v-model="newConditionValue">
                                                            <option value="">Select</option>
                                                            <option v-for="(conditionValueOption, index) in conditionValueOptions(newConditionType)"
                                                                    v-bind:key="index"
                                                                    v-bind:value="conditionValueOption.value">{{conditionValueOption.label}}</option>
                                                        </select>
                                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </template>
                                                <template v-else-if="isConditionValueDate(newConditionType)">
                                                    <ValidationProvider rules="required" v-slot="{ errors }" v-bind:skipIfEmpty="false">
                                                        <flat-pickr v-model="newConditionValue" v-bind:config="flatPickrConfig" id="dateNew"></flat-pickr>
                                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </template>
                                                <template v-else-if="isConditionValueSelectMultiple(newConditionType, newConditionOperator)">
                                                    <div class="edit-automation-condition__value--select-multiple"
                                                         v-on:click.stop="toggleMultipleSelector(1000)"
                                                         v-bind:class="{'edit-automation-condition__value--select-multiple--open' : showMultipleSelectorIndex != null && showMultipleSelectorIndex === 1000}">
                                                        <ValidationProvider rules="required" v-slot="{ errors }" v-bind:skipIfEmpty="false">
                                                            <input type="hidden" v-model="newConditionValue"/>
                                                            {{numberSelectedForCondition({type: newConditionType, value: newConditionValue})}} selected
                                                            <i class="fas fa-angle-down" v-if="showMultipleSelectorIndex === null || showMultipleSelectorIndex !== 1000"></i>
                                                            <i class="fas fa-angle-up" v-if="showMultipleSelectorIndex != null && showMultipleSelectorIndex === 1000"></i>
                                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="edit-automation-condition__cta">
                                                <a v-on:click.stop="addCondition" class="edit-dynamic-list__action edit-dynamic-list__action--yes"><i class="fas fa-check"></i></a>
                                                <a v-on:click.stop="cancelAdd" class="edit-dynamic-list__action edit-dynamic-list__action--no"><i class="fas fa-times"></i></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="showMultipleSelectorIndex != null && showMultipleSelectorIndex === 1000" class="col-12 edit-automation-condition">
                                        <div class="edit-automation-condition__value__multiple-selector">
                                            <table>
                                                <template v-if="isConditionTypeRoomType(newConditionType)">
                                                    <tr v-for="(roomType, index) in roomTypes" v-bind:key="index">
                                                        <td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, roomType.reference)"
                                                                v-on:change="updateInValueOnCondition(null, roomType.reference, $event.target.checked)"></td>
                                                        <td>{{roomType.name}}</td>
                                                    </tr>
                                                </template>
                                                <template v-if="isConditionTypePaymentState(newConditionType)">
                                                    <tr><td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, 'waiting-for-deposit')"
                                                                v-on:change="updateInValueOnCondition(null, 'waiting-for-deposit', $event.target.checked)"></td></tr>
                                                        <td>Waiting for deposit</td>
                                                    <tr><td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, 'confirmed')"
                                                                v-on:change="updateInValueOnCondition(null, 'confirmed', $event.target.checked)"></td></tr>
                                                        <td>Deposit received</td>
                                                    <tr><td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, 'paid')"
                                                                v-on:change="updateInValueOnCondition(null, 'paid', $event.target.checked)"></td></tr>
                                                        <td>Paid</td>
                                                    <tr><td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, 'outstanding-account')"
                                                                v-on:change="updateInValueOnCondition(null, 'outstanding-account', $event.target.checked)"></td></tr>
                                                        <td>Outstanding account</td>
                                                </template>
                                                <template v-if="isConditionTypeChannel(newConditionType)">
                                                    <tr v-for="(conditionValueOption, index) in conditionValueOptions(newConditionType)" v-bind:key="index">
                                                        <td><input type="checkbox"
                                                                v-bind:checked="isInValueSetOnCondition(null, conditionValueOption.value)"
                                                                v-on:change="updateInValueOnCondition(null, conditionValueOption.value, $event.target.checked)"
                                                                v-bind:disabled="automation.active"></td>
                                                        <td>{{conditionValueOption.label}}</td>
                                                    </tr>
                                                </template>
                                            </table>
                                        </div>
                                    </div>

                                    <div v-show="!automation.active && !addingCondition" class="row edit-dynamic-list__item">
                                        <div class="col-12">
                                            <a v-on:click="showAddCondition" class="edit-dynamic-list__action edit-dynamic-list__action--add">+</a>
                                        </div>
                                    </div>

                                </div>

                                <ValidationProvider ref="conditionsProvider" name="conditions" rules="conditionsValid" :value="automation.conditions" v-slot="{ errors }">
                                    <div class="col-12 form__error" v-if="errors.length">{{ errors[0] }}</div>
                                </ValidationProvider>

                            </div>
                        </div>
                        <div class="sw-modal-actions">
                            <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                                {{infoMessage}}
                            </div>
                            <div v-show="updating && !success">
                                <Spinner/>
                            </div>
                            <div class="row" v-show="!updating && !success">
                                <div class="col-6">
                                    <button type="button" class="btn btn-secondary" v-on:click.stop="cancel">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary">
                                        <template v-if="editingAutomation">Save</template>
                                        <template v-if="!editingAutomation">Create</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../Spinner.vue'
    import Tooltip from '../Tooltip'
    import { store, getters } from '../../store.js'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    
    import {automationMixin} from "../../mixins/AutomationMixin"
    import {whatsAppMixin} from "../../mixins/WhatsAppMixin"
    import {whatsAppTemplatesMixin} from "../../mixins/WhatsAppTemplatesMixin"

    import FlatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import 'flatpickr/dist/themes/material_blue.css';

    export default {
        name: 'EditTimedAutomation',
        components: {
            Spinner, ValidationObserver, ValidationProvider, Tooltip, FlatPickr
        },
        mixins: [ automationMixin, whatsAppMixin, whatsAppTemplatesMixin ],
        props: {
        },
        data: function() {
            return {
                isNew: true,
                copy: {},
                flatPickrConfig: {
                    mode: "single",
                    enableTime: true,
                    time_24hr: true,
                    altInput: true,
                    altFormat: "j M @ H:i",
                    dateFormat: "Z",
                    minDate: this.minDate
                },
                showAdvancedOptions: false,
                updating: false,
                error: false,
                success: false,
                infoMessage: "Info message",
                showTooltipFlow: false,
                showTooltipAutomationType: false,
                showTooltipShowBookingSummary: false,
                showTooltipShowPricing: false,
                showTooltipShowOnFrontDeskApp: false,
                showTooltipNudgeGuest: false,
                showTooltipSendSMS: false,
                showTooltipCommunicationMode: false,
                showTooltipPauseNewTasks: false,
                showTooltipConditions: false
            }
        },
        computed: {
            daysFromOptions: function() {
                let options = [];
                if (this.isFrontDeskGuestForm) {
                    options.push({"key": 0, "value": "On the day of Check-In"});
                    return options;
                }
                let eventName = "";
                switch (this.automation.when.strategy) {
                    case 'immediate':
                    case 'after-booking':
                        eventName = "Booking";
                        break;
                    case 'before-or-after-arrival':
                        eventName = "Check-In";
                        break;
                    case 'before-or-after-departure':
                        eventName = "Check-Out";
                        break;
                    default:
                        return [];
                }
                if (this.automation.when.strategy === 'after-booking') {
                    options.push({"key": 0, "value": "Immediately"});
                }
                if (this.automation.when.strategy.startsWith('before-or-after')) {
                    options.push({"key": -35, "value": "35 days before " + eventName});
                    options.push({"key": -30, "value": "30 days before " + eventName});
                    options.push({"key": -28, "value": "28 days before " + eventName});
                    options.push({"key": -21, "value": "21 days before " + eventName});
                    options.push({"key": -14, "value": "14 days before " + eventName});
                    options.push({"key": -10, "value": "10 days before " + eventName});
                    for (let i = -7; i < -1; i++) {
                        options.push({"key": i, "value": -i + " days before " + eventName});
                    }
                    options.push({"key": -1, "value": "1 day before " + eventName});
                    options.push({"key": 0, "value": "On the day of " + eventName});
                }
                options.push({"key": 1, "value": "1 day after " + eventName});
                for (let i = 2; i < 8; i++) {
                    options.push({"key": i, "value": i + " days after " + eventName});
                }
                options.push({"key": 14, "value": "14 days after " + eventName});
                options.push({"key": 21, "value": "21 days after " + eventName});
                return options;
            },
            shouldShowTimeOfDay: function() {
                if (this.isFrontDeskGuestForm) {
                    return false;
                }
                if (this.automation.when.strategy === 'after-booking' && this.automation.when.numberOfDaysFrom === 0) {
                    // this.showTimeOfDay = false;
                    return false;
                } else {
                    // this.showTimeOfDay = true;
                    return true;
                }
            },
            canShowWhatsApp: function() {
                return getters.canShowWhatsApp();
            },
            canShowWhatsAppForForm: function() {
                if (this.whatsAppBusiness && this.whatsAppBusiness.status === 'active' &&
                    this.whatsAppTemplates.length > 0 && this.whatsAppTemplates.filter(template => template.contentType === 'form-invite' && template.status === 'approved').length > 0
                ) {
                    return true;
                }
                return false;
            },
            messageMethod: {
                get() {
                    if (this.automation.sendWhatsApp) return 'whatsapp';
                    if (this.automation.sendSMS) return 'sms';
                    return 'no';
                },
                set(value) {
                    this.automation.sendWhatsApp = (value === 'whatsapp');
                    this.automation.sendSMS = (value === 'sms');
                }
            }
        },
        methods: {
            setStrategy: function(strategy) {
                this.automation.when.strategy = strategy;
                if (strategy === 'after-booking') {
                    if (this.automation.when.numberOfDaysFrom < 0) {
                        this.automation.when.numberOfDaysFrom = 0;
                    }
                } else {
                    if (this.automation.when.numberOfDaysFrom === 0) {
                        this.automation.when.numberOfDaysFrom = 1;
                    }
                }
            },
            checkTimeOfDayWhenChangingStrategy: function() {
                if (this.automation.when.strategy !== 'immediate' && this.automation.when.timeOfDay === "00:00") {
                    this.automation.when.timeOfDay = "07:00";
                }
            },
            setFocusOnThirdPartyEmail: function() {
                this.$nextTick(() => this.$refs.thirdPartyEmailInput.focus());
            },
            toggleAdvancedOptions: function() {
                this.showAdvancedOptions = !this.showAdvancedOptions;
            },
            cancel: function() {
                console.log("cancel");

                if (typeof this.automation.reference === 'undefined') {
                    // if this is a new, unsaved automation, then cancelling should remove it
                    console.log("new - delete temporary automation");
                    this.$root.$emit('delete-new-automation');
                } else {
                    // else we need to reset the values to what they were before
                    this.automation.type = this.copy.type;
                    this.automation.name = this.copy.name;
                    this.automation.active = this.copy.active;
                    this.automation.showBookingSummary = this.copy.showBookingSummary;
                    this.automation.showPricing = this.copy.showPricing;
                    this.automation.showOnFrontDeskApp = this.copy.showOnFrontDeskApp;
                    this.automation.sendSMS = this.copy.sendSMS;
                    this.automation.sendWhatsApp = this.copy.sendWhatsApp;
                    this.automation.communicationMode = this.copy.communicationMode;
                    this.automation.bccHost = this.copy.bccHost;
                    this.automation.thirdPartyEmail = this.copy.thirdPartyEmail;
                    this.automation.useDueDate = this.copy.useDueDate;
                    this.automation.when.strategy = this.copy.when.strategy;
                    this.automation.when.numberOfDaysFrom = this.copy.when.numberOfDaysFrom;
                    this.automation.when.timeOfDay = this.copy.when.timeOfDay;
                    if (this.copy.when.strategy === 'after-booking' && this.copy.when.numberOfDaysFrom === 0) {
                        this.automation.when.strategy = 'immediate';
                    }
                    this.automation.pauseNewTasks = this.copy.pauseNewTasks;
                    this.automation.conditions.splice(0, this.automation.conditions.length);
                    if (!this.copy.appliesToAllBookings) {
                        this.automation.appliesToAllBookings = false;
                        this.automation.conditions.push(...this.copy.conditions);
                    } else {
                        this.automation.appliesToAllBookings = true;
                    }
                    this.$root.$emit('finished-editing-automation', this.automation);
                }
            },
            saveAutomation: function() {
                if (!this.$refs.conditionsProvider.validate(this.automation.conditions)) {
                    console.log("Conditions invalid");
                    return;
                }

                this.$refs.automationForm.validate().then(success => {
                    console.log("Validated: " + success);
                    if (!success) {
                        return;
                    }

                    console.log("saving automation");
                    this.error = false;

                    let body = {
                        "type": this.automation.type,
                        "name": this.automation.name,
                        "active": this.automation.active,
                        "showBookingSummary": this.automation.showBookingSummary,
                        "showPricing": this.automation.showPricing,
                        "showOnFrontDeskApp": this.automation.showOnFrontDeskApp,
                        "useDueDate": this.automation.useDueDate,
                        "sendSMS": this.automation.sendSMS,
                        "sendWhatsApp": this.automation.sendWhatsApp,
                        "communicationMode": this.automation.communicationMode,
                        "trigger": "booking-placed",
                        "when": {},
                        "pauseNewTasks": this.automation.pauseNewTasks
                    };

                    if (this.usingTemplate) {
                        body.templateReference = this.templateReference;
                    }

                    if (this.automation.when.strategy === 'after-booking' && this.automation.when.numberOfDaysFrom === 0) {
                        body.when.strategy = "immediate";
                    } else {
                        body.when.strategy = this.automation.when.strategy;
                        body.when.numberOfDaysFrom = this.automation.when.numberOfDaysFrom;
                        if (this.isFrontDeskGuestForm) {
                            body.when.timeOfDay = "00:00";
                        } else {
                            body.when.timeOfDay = this.automation.when.timeOfDay;
                        }
                    }

                    if (this.isSendEmail) {
                        body.bccHost = this.automation.bccHost;
                        body.thirdPartyEmail = this.automation.thirdPartyEmail;
                    }

                    if (!this.automation.appliesToAllBookings) {
                        body.conditions = [];
                        for (let condition of this.automation.conditions) {
                            let temp = {type: condition.type, operator: condition.operator, value: condition.value};
                            if (condition.reference) {
                                temp.reference = condition.reference;
                            }
                            body.conditions.push(temp);
                        }
                    }

                    console.log(body);

                    let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                        + '/automations/';

                    if (typeof this.automation.reference === 'undefined') {
                        // adding a new automation
                        switch (this.automation.type) {
                            case 'send-omni-channel-guest-form':
                                url += "omni-channel-forms"
                                break;
                            case 'send-email':
                                url += "emails"
                                break;
                            case 'send-sms':
                                url += "smss"
                                break;
                            case 'send-whatsapp':
                                url += "whatsapps"
                                break;
                            case 'guest-form':
                                url += "forms"
                                break;
                            case 'todo':
                                url += "todos"
                                break;
                            case 'upsell':
                                url += "upsells"
                                break;
                            case 'webhook':
                                url += "webhooks"
                                break;
                        }
                        console.log(url);

                        this.updating = true;
                        this.infoMessage = "Creating automation";

                        this.$http.post(url, body
                        ).then(response => {
                            console.log("Automation created");
                            if (response.data) {
                                Object.assign(this.automation, response.data);
                                this.infoMessage = "Automation created";
                                // this.automation.condition = this.auto.condition;
                                this.success = true;
                                setTimeout(() => {
                                    this.updating = false;
                                    this.$root.$emit('finished-editing-automation', this.automation);
                                }, 2000);
                            }
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error creating automation";
                            }
                        });

                    } else {
                        // updating an automation
                        url += this.automation.reference;
                        console.log(url);
                        body.reference = this.automation.reference;

                        this.updating = true;
                        this.infoMessage = "Saving automation";

                        this.$http.put(url, body
                        ).then(() => {
                            console.log("Automation updated:")
                            this.infoMessage = "Automation updated"
                            this.success = true;
                            setTimeout(() => {
                                this.updating = false;
                                this.$root.$emit('finished-editing-automation', this.automation);
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error updating automation";
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            console.log("Mounting edit / add automation");
            if (this.automation.when.strategy === 'immediate') {
                console.log("Immediate");
                this.automation.when.strategy = 'after-booking';
                this.automation.when.numberOfDaysFrom = 0;
            }
            if (typeof this.automation.reference !== 'undefined') {
                this.isNew = false;
                this.copy.type = this.automation.type;
                this.copy.name = this.automation.name;
                this.copy.active = this.automation.active;
                this.copy.showBookingSummary = this.automation.showBookingSummary;
                this.copy.showPricing = this.automation.showPricing;
                this.copy.showOnFrontDeskApp = this.automation.showOnFrontDeskApp;
                this.copy.sendSMS = this.automation.sendSMS;
                this.copy.sendWhatsApp = this.automation.sendWhatsApp;
                this.copy.communicationMode = this.automation.communicationMode;
                this.copy.bccHost = this.automation.bccHost;
                this.copy.thirdPartyEmail = this.automation.thirdPartyEmail;
                this.copy.useDueDate = this.automation.useDueDate;
                this.copy.when = {};
                this.copy.when.strategy = this.automation.when.strategy;
                this.copy.when.numberOfDaysFrom = this.automation.when.numberOfDaysFrom;
                this.copy.when.timeOfDay = this.automation.when.timeOfDay;
                this.copy.pauseNewTasks = this.automation.pauseNewTasks;
                this.copy.appliesToAllBookings = this.automation.appliesToAllBookings;
                this.copy.conditions = [];
                if (!this.copy.appliesToAllBookings) {
                    this.copy.conditions.push(...this.automation.conditions);
                    for (let i = 0; i < this.automation.conditions.length; i++) {
                        this.showConditionOptions.push(false);
                    }
                }
            } else {
                this.isNew = true;
                this.fetchAutomationTemplates();
            }
            this.providerChannels = store.currentEstablishmentProviderChannels;
            this.roomTypes = getters.getCurrentEstablishment().roomTypes;
            this.$refs.nameInput.focus();
            this.fetchWhatsApp(store.currentEstablishmentReference);
            this.fetchWhatsAppTemplates();
            // effectively tell the automation mixin be aware it is exiting, so that when it 
            // finishes editing it can notify the parent
            this.editAutomation();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/forms.scss";
    @import "../../styles/components/modal.scss";
    @import "../../styles/components/edit_form_component.scss";
    @import "../../styles/components/edit_automation.scss";
    @import "../../styles/components/question_answer.scss";
</style>

<!--These are overrides for the flatpickr inputs -->
<style lang="scss">
    @import "../../styles/overrides/flatpickr";
    @import "../../styles/overrides/flatpickr_edit_automation";
</style>